<template>
    <b-modal id="modal-commentary-teacher"
    :hide-footer="true" 
    :hide-header="true" 
    :centered="true">
    <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modal-commentary-teacher')">
        <div class="" v-if="teacherInformation">
            <div class="header-commentary card card_teacher list">
                <div class="d-flex">
                    <div class="perfil">
                        <b-avatar
                            variant="light"
                            :src="teacherInformation.person.photo ? teacherInformation.person.photo : urlPhoto.PHOTO_TEACHER_DEFAULT"
                            size="4.2rem"  
                        ></b-avatar>
                        <b-form-rating :value="teacherInformation.totalQualification" no-border readonly style="pointer-events:none;"></b-form-rating>
                        <p class="comment-title">{{teacherInformation.totalCommentary}} {{$t('modals.commentary.text.1')}}</p>
                    </div>
                    <div class="info">
                        <h6>{{teacherInformation.person.strFullName}}</h6>
                        <p>
                            <icon name="location" />{{teacherInformation.person.countryOriginDescription}}
                        </p>
                    </div>
                </div>
                <div class="text-center mt-3" v-if="flagEdit">
                    <b-button variant="primary" size="sm" @click="ShowModalCalification">
                        {{ $i18n.locale === 'en' ? 'Leave a review' : 'Dejar una reseña' }}
                    </b-button>
                </div>
            </div>
            <div class="content-commentary">
                <h6 v-if="teacherInformation.personsTeachersCalifications.length > 0">{{$t('modals.commentary.titulo')}}</h6>
                <h6 v-else>{{$t('modals.commentary.vacio')}}</h6>
                <div class="scroll-commentary" v-if="teacherInformation.personsTeachersCalifications.length > 0">
                    <div class="commentary" v-for="(item,i) in teacherInformation.personsTeachersCalifications" :key="i" :id="'comentary_'+i">
                        <div class="card card_teacher list">
                            <div class=" perfil">
                                <b-avatar
                                    variant="light"
                                    :src="item.personsStudents.person.photo ? item.personsStudents.person.photo : urlPhoto.PHOTO_STUDENT_DEFAULT"
                                    size="65px"
                                ></b-avatar>
                            </div>
                            <div class=" info">
                                <h6 class="mb-0">{{item.personsStudents.person.strFullName}}</h6>
                                <div class="content-star">
                                    <b-form-rating :value="item.qualification" readonly style="pointer-events:none;"></b-form-rating>
                                </div>
                                <p class="pt-0">
                                    {{item.commentary}}
                                </p>
                                <a v-if="flagEdit && item.personStudentId == User.personStudentId" @click="ShowModalCalification">Editar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { IMAGENES } from '@/assets/js/appConstants'; 
export default {
    data() {
        return {
            urlPhoto: IMAGENES,
        }
    },
    props: {
        teacherInformation:{
            type: Object
        },
        flagEdit:{
            type: Boolean
        }
    },
    computed: {
        User: {
            get() { return this.$store.state.user; }
        }
    },
    mounted() {
        console.log('IMAGENES.PHOTO_TEACHER_DEFAULT',IMAGENES.PHOTO_TEACHER_DEFAULT)
    },
    methods: {
        ShowModalCalification(){
            this.$emit('open-window-recommend')
        }
    }
}
</script>